export type HistoricoStatusValue =
  | 'PENDENTE'
  | 'ANALISE_DE_PRODUTO'
  | 'INCLUSAO_DE_FABRICANTE'
  | 'RASCUNHO_QUICK'
  | 'RASCUNHO_OK'
  | 'ATIVADO'
  | 'DESATIVADO'
  | 'RASCUNHO'
  | 'ERRO'
  | 'REALIZADA';

export type HistoricoStatus = {
  id: number;
  data: string;
  status: HistoricoStatusValue;
  usuario: string | null;
};

export const STATUS_LABELS: Record<string, string> = {
  PENDENTE: 'Pendente',
  ANALISE_DE_PRODUTO: 'Análise de produto',
  INCLUSAO_DE_FABRICANTE: 'Inclusão de fabricante',
  RASCUNHO_QUICK: 'Rascunho quick',
  RASCUNHO_OK: 'OK Rascunho',
  ATIVADO: 'Ativado',
  DESATIVADO: 'Desativado',
  RASCUNHO: 'Rascunho',
  ERRO: 'Erro',
  REALIZADA: 'Realizada',
};

export const MANUAL_STATUS_OPTIONS: { id: HistoricoStatusValue; value: HistoricoStatusValue; label: string }[] = [
  { id: 'PENDENTE', value: 'PENDENTE', label: STATUS_LABELS.PENDENTE },
  { id: 'ANALISE_DE_PRODUTO', value: 'ANALISE_DE_PRODUTO', label: STATUS_LABELS.ANALISE_DE_PRODUTO },
  { id: 'INCLUSAO_DE_FABRICANTE', value: 'INCLUSAO_DE_FABRICANTE', label: STATUS_LABELS.INCLUSAO_DE_FABRICANTE },
  { id: 'RASCUNHO_OK', value: 'RASCUNHO_OK', label: STATUS_LABELS.RASCUNHO_OK },
];

export const PORTAL_STATUSES: HistoricoStatusValue[] = ['ATIVADO', 'DESATIVADO', 'RASCUNHO', 'ERRO'];

export const getStatusLabel = (status: string): string => STATUS_LABELS[status] ?? status;
